import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-stripe-success',
  templateUrl: './stripe-success.component.html',
})
export class StripeSuccessComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    // Stripe webhook actualizará el estado del candidato en segundo plano.
    // Redirigimos a /mis-alertas después de 4 segundos.
    setTimeout(() => this.router.navigate(['/mis-alertas']), 4000);
  }
}
